import { useMemo } from 'react';

import { useDateLang } from '~/hooks/useDateLang';
import { mainStore } from '~/stores';
import { notSSRFormatPriceWithCurrency } from '~/utils/formaters';

import {
  formatMembershipDate,
  type MembershipFormatters,
} from '../domain/format';

/**
 * Money and date formatting of the membership screens: money through the
 * site's price formatter (symbol, space, amount, cents when there are any —
 * "₯ 8.60" at CityDrinks), dates in the site's date locale.
 */
export const useMembershipFormatters = (): MembershipFormatters => {
  const { locale } = useDateLang();

  return useMemo(
    () => ({
      money: (amountMinor, currency) =>
        notSSRFormatPriceWithCurrency(
          mainStore.convertPenceToPounds(amountMinor),
          undefined,
          currency.trim().toUpperCase(),
        ),
      date: (iso) => formatMembershipDate(iso, locale),
    }),
    [locale],
  );
};
